import type { ReactElement, ReactNode } from 'react';

export interface SectionHeaderProps {
  /** Decorative glyph rendered in a tonal circle to the left of the title.
   *  Pure visual rhyme with the left-rail nav icon — keeps the user's
   *  spatial orientation as they jump between sections. */
  icon: ReactElement;
  title: string;
  subtitle: string;
}

/** Shared header strip for every settings section. Centralised so the
 *  three sections (Appearance / Language / Account) stay visually
 *  identical without three near-duplicate snippets drifting over time. */
export function SectionHeader({ icon, title, subtitle }: SectionHeaderProps): ReactNode {
  return (
    <header className="flex items-center gap-3">
      <span
        aria-hidden
        className="inline-flex items-center justify-center"
        style={{
          width: 36,
          height: 36,
          background: 'var(--vq-paper-raised)',
          border: '1px solid var(--vq-rule)',
          borderRadius: 'var(--vq-radius-pill)',
          color: 'var(--vq-ink-2)',
          flexShrink: 0,
        }}
      >
        {icon}
      </span>
      <div className="flex flex-col">
        <h2
          className="font-serif text-2xl font-medium"
          style={{ color: 'var(--vq-ink)', margin: 0, lineHeight: 1.15 }}
        >
          {title}
        </h2>
        <p
          className="mt-0.5 font-serif"
          style={{ color: 'var(--vq-ink-3)', fontSize: 14, margin: 0 }}
        >
          {subtitle}
        </p>
      </div>
    </header>
  );
}
